export const STORAGE_KEY = {
    TOKEN: 'token',
    LANGUAGE: 'SELECTED_LANGUAGE',
}